import styled from "styled-components";

const CategoriesWrapperStyled = styled.div`
    position:relative;
  background-color: #121212;
  margin-top: -9%;
`

export default CategoriesWrapperStyled;